import { Theme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import createStyles from "@mui/styles/createStyles";
import imgLD9 from "assets/images/pngs/ld9.png";

interface IProjectionBodyStylesProps {
    canSeeBridge: boolean;
}

export default makeStyles((theme: Theme) =>
    createStyles({
        wrapper: {
            padding: theme.spacing(0, 4),
        },
        headerContainer: {
            paddingTop: theme.spacing(1),
        },
        mainTitle: {
            fontSize: 34,
            marginBottom: theme.spacing(1),
        },
        intro: {
            color: theme.palette.secondary.main,
            fontSize: 16,
        },
        secondaryTitle: {
            fontSize: 24,
            fontWeight: 600,
            letterSpacing: -0.18,
            marginBottom: (props: IProjectionBodyStylesProps) =>
                props.canSeeBridge ? theme.spacing(2) : theme.spacing(4),
        },
        proGraphMsgWrapper: {
            position: "relative",
            height: "60vh",
            width: "100%",
            backgroundImage: (props: IProjectionBodyStylesProps) => (props.canSeeBridge ? `url(${imgLD9})` : "none"),
            backgroundRepeat: "no-repeat",
            backgroundSize: "contain",
            backgroundPosition: "center",
            border: "1px solid #EAEAEA",
            borderRadius: "11px",
            "& > *": {
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
            },
        },
        chartWrapper: {
            width: "98%",
            minHeight: 450,
            height: "calc(100vh - 530px)",
            margin: `0 auto ${theme.spacing(1.5)}`,
        },
        outroWrapper: {
            display: "flex",
            alignItems: "center",
            marginBottom: theme.spacing(10),
        },
        outroTitle: {
            fontSize: 20,
            fontWeight: 600,
            letterSpacing: 0.15,
            marginBottom: theme.spacing(2),
        },
        outroText: {
            fontSize: 14,
            color: theme.palette.text.secondary,
        },
    })
);
